import type { ConversationNodeMessengerInput } from 'lib-shared-types-api';

type RoutedThroughMessengerInputProps = {
  node: ConversationNodeMessengerInput;
};

export function RoutedThroughMessengerInput({
  node,
}: RoutedThroughMessengerInputProps): JSX.Element {
  return (
    <>
      Input · <strong>{node.input}</strong>
    </>
  );
}
